const ItemOnMenu = ({num}) => {
    return (
        <div className='itemonmenu'>
            <span>Item Menu {num}</span>
        </div>
    )
}
export default ItemOnMenu
